module.exports = __webpack_public_path__ + "static/media/badge-wordpress.18952823.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/badge-wordpress.png
// module id = 299
// module chunks = 0